module.exports = __webpack_public_path__ + "img/mobile-notch.c6ca38be.svg";